import { useEffect, useState } from "react";
import { HttpService } from "../../services/HttpService";
import { useTranslation } from 'react-i18next';

const FormFields = (props: any) => {
  let id: any = props.id || "";
  const { t } = useTranslation();
  const [formFields, setFormFields] = useState([]);
  useEffect(() => {
    getFormFields();
  }, [id]);

  const getFormFields = async () => {
    const result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/attendance/${id}/view-model-array`);
    setFormFields(result?.data || []);
  }
  return (
    <>
      {(formFields.map((formField: any, index: any) => (
        <p key={index}>{formField.label}:
          {((typeof formField.value === 'boolean') ?
            <b> {((formField.value) ? t('yes') : t('no'))}</b>
            :
            <b> {String(formField.value || "")}</b>
          )}
        </p>
      )))}
    </>
  )
}

export default FormFields